import { textLinkTheme } from "hardcover-ui/theme/components/text";
import { ComponentTheme } from "hardcover-ui/types/base";

export type ButtonThemeProps = {
  variant:
    | "primary"
    | "secondary"
    | "tertiary"
    | "accent"
    | "warning"
    | "ghost"
    | "unstyled"
    | "link"
    | "dangerLink"
    | "outline"
    | "pill"
    | "none"
    | "base";
  size: "none" | "xs" | "sm" | "md" | "lg";
};

const buttonBaseStyles =
  "inline-flex items-center focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-ring border rounded-lg active:translate-y-1 transition-all w-fit";

export const buttonTheme: ComponentTheme<ButtonThemeProps> = {
  variant: {
    none: "hover:bg-secondary focus:ring-secondary",
    base: buttonBaseStyles,
    primary: `${buttonBaseStyles} bg-primary text-primary-foreground border-primary hover:opacity-90`,
    secondary: `${buttonBaseStyles} bg-card text-card-foreground border-secondary hover:bg-secondary`,
    tertiary: `${buttonBaseStyles} bg-background text-foreground border-tertiary hover:bg-tertiary`,
    accent: `${buttonBaseStyles} bg-accent text-accent-foreground border-accent hover:opacity-90`,
    warning: `${buttonBaseStyles} bg-destructive text-destructive-foreground border-destructive hover:opacity-90`,
    ghost:
      "rounded-lg active:translate-y-1 transition-all w-fit inline-flex items-center bg-secondary/30 hover:bg-secondary",
    unstyled: "inline-flex items-center",
    outline: `${buttonBaseStyles} border border-border hover:border-primary`,
    link: textLinkTheme.variant.normal,
    pill: "inline-flex flex-row items-center bg-secondary hover:bg-primary/10 text-muted-foreground rounded-full hover:ring-2 hover:ring-primary",
    dangerLink:
      "text-destructive underline underline-offset-2 hover:text-destructive/80",
  },
  size: {
    none: "",
    xs: "py-0.2 px-1.5 text-sm font-normal",
    sm: "py-1 px-2 text-sm font-medium",
    md: "py-2 px-4 text-sm font-medium",
    lg: "py-3 px-4 text-lg font-medium shadow-button active:shadow-none",
  },
};
